import { AlertService } from './alert.service';
import { Alert, AlertType } from './alert.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  alerts: Alert[] = [];

  constructor(private alertService: AlertService) {}

  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: Alert) => {
      if (!alert) {
        this.alerts = [];
        return;
      }
      this.alerts = [];
      this.alerts.push(alert);

      setTimeout(function() {
        this.removeAlert(alert);
      }.bind(this), 3000);

    });

  }

  removeAlert(alert: Alert) {
    this.alerts = this.alerts.filter(x => x !== alert);
  }

  cssClass(alert: Alert) {
    if (!alert) {
      return;
    }

    switch (alert.type) {
      case AlertType.Success:
        return 'alert custom-alert-success';
      case AlertType.Error:
        return 'alert custom-alert-danger';
      case AlertType.Info:
        return 'alert custom-alert-info';
      case AlertType.Warning:
        return 'alert custom-alert-warning';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/alert/alert.component.ts